/* Utils */
import { generateSelectEntityById, generateSelectEntitiesByIdsList } from '../utils/generators/selectorGenerators';

export const selectAllChannels = (state) => state.channels;

export const selectAllChannelsBySourceProvider = (sourceProvider) => (state) => {
  const channels = selectAllChannels(state);
  return channels.filter((channel) => channel.sourceProvider === sourceProvider);
};

export const selectChannelById = generateSelectEntityById(selectAllChannels);

export const selectChannelsListByIdsList = generateSelectEntitiesByIdsList(selectAllChannels);
